import { render, staticRenderFns } from "./AssignStoreToTruck.vue?vue&type=template&id=35e209c7&scoped=true"
import script from "./AssignStoreToTruck.vue?vue&type=script&lang=js"
export * from "./AssignStoreToTruck.vue?vue&type=script&lang=js"
import style0 from "./AssignStoreToTruck.vue?vue&type=style&index=0&id=35e209c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e209c7",
  null
  
)

export default component.exports